import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    defaultMessage: "Channels permissions",
    id: "vz3yxp",
  },
  allowAllChannels: {
    defaultMessage: "Allow access to orders of all channels",
    id: "9FGTOt",
  },
  selectChannels: {
    defaultMessage: "Select visible order channels",
    id: "vprU7C",
  },
  searchChannels: {
    defaultMessage: "Search channels",
    id: "0HBlkO",
  },
});
